import { createSlice } from '@reduxjs/toolkit';
import dayjs from 'dayjs';
import { getCurrentMonthStartDate } from 'utils/dateUtil';

const activitySlice = createSlice({
  name: 'activity',
  initialState: {
    rows: [],
    typeRows: [],
    filter: {
        member: 0,
        keyword: null,
        startDate: dayjs(getCurrentMonthStartDate()),
        endDate: dayjs(new Date())
    }
  },
  reducers: {
    replaceData(state, action) {
      state.rows = action.payload;
    },
    replaceTypeData(state, action) {
      state.typeRows = action.payload;
    },
    replaceFilter(state, action) {
      state.filter.member = action.payload.member ?? 0;
      state.filter.keyword = action.payload.keyword ?? null;
      state.filter.startDate = action.payload.startDate;
      state.filter.endDate = action.payload.endDate;
    },
  },
});

export const activityActions = activitySlice.actions;

export default activitySlice;